/**
 * TRAVEL (ZONE) FEE OPT-IN — Paul's working rule (Oct 8 2026):
 *   1. A photographer covering the address in their zone 1 exists and the
 *      agent asked for no one: no travel fee.
 *   2. The agent is charged ONLY when they explicitly REQUEST a specific
 *      photographer and the address is in that photographer's zone 2/3. The
 *      fee is its own line ("Extended service area", to the cent) in the
 *      quote before checkout and in the total they accept. It stays on the
 *      order only while THAT photographer is the one assigned; if anyone else
 *      ends up on the visit, the line drops away (and if the order was
 *      already charged, the invoice shows it overpaid: the existing refund
 *      flow, OrderState.REFUND).
 *   3. Any other out-of-zone assignment: the COMPANY pays the photographer
 *      the zone fee (fee == provider payout, territory.ts); the agent is not
 *      charged.
 * Never charge a fee the agent did not opt into at order time.
 *
 * Gated by company.travel_fee_optin (default off), forced on for a tenant
 * whose sales demo is on. Off: nothing here is written or read.
 */

export const TRAVEL_FEE_DESCRIPTION = 'Extended service area';

/** What the agent opted into at order time (order.data.travel_fee_optin): the requested photographer, their zone, the fee. */
export interface TravelFeeOptin {
  provider_id: string;
  zone: 2 | 3;
  /** The customer fee to the cent, "20.00". */
  fee: string;
}
